import { useMemo } from 'react';
import { useRole } from 'lib/evi-role-action/hoc';

interface AuthorityProps {
  ctrl: string;
  role: string[];
}

const useAuthorityAll = ({ ctrl, role }: AuthorityProps) => {
  const initStaff = {
    type: 'staff' as const,
    module: 'resource' as const,
    controller: ctrl.trim(),
    action: role.map((r) => r.trim())
  };

  const initMerchant = {
    type: 'merchant' as const,
    module: 'resource' as const,
    controller: ctrl.trim(),
    action: role.map((r) => r.trim())
  };

  const [staffRole] = useRole(initStaff);
  const [merchantRole] = useRole(initMerchant);

  const roleList = useMemo(() => {
    return role.reduce((acc: Record<string, boolean>, cur: string) => {
      const hasStaffRole = typeof staffRole === 'object' && staffRole !== null && cur in staffRole;
      const hasMerchantRole =
        typeof merchantRole === 'object' && merchantRole !== null && cur in merchantRole;

      if (hasStaffRole && hasMerchantRole) {
        const staffValue = (staffRole as Record<string, any>)[cur];
        const merchantValue = (merchantRole as Record<string, any>)[cur];

        if (staffValue && merchantValue) {
          return { ...acc, [cur]: true };
        }
      }
      return { ...acc, [cur]: false };
    }, {});
  }, [role, staffRole, merchantRole]);

  return roleList;
};

export default useAuthorityAll;
